import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pl-2" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Deactivate")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Add")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_radio = _resolveComponent("va-radio")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_LevelSelector = _resolveComponent("LevelSelector")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_card_actions = _resolveComponent("va-card-actions")!
  const _component_va_card = _resolveComponent("va-card")!

  return (_openBlock(), _createBlock(_component_va_card, { class: "flex" }, {
    default: _withCtx(() => [
      _createVNode(_component_va_card_title, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.cardTitle), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", null, [
        _createVNode(_component_va_form, null, {
          default: _withCtx(() => [
            _createVNode(_component_va_input, {
              class: "pb-1",
              placeholder: "Category Name",
              modelValue: _ctx.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
              label: "Name"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_popover, { message: "Coming Soon" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listModeOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_va_radio, {
                      disabled: "",
                      key: option,
                      option: option,
                      modelValue: _ctx.listMode,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.listMode) = $event))
                    }, null, 8, ["option", "modelValue"]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_va_input, {
              class: "pt-2",
              type: "textarea",
              "min-rows": 3,
              "max-rows": 5,
              modelValue: _ctx.description,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
              label: "Description"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_LevelSelector, { onChanged: _ctx.setLevel }, null, 8, ["onChanged"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_va_card_actions, { align: "between" }, {
        default: _withCtx(() => [
          (!_ctx.newRecord)
            ? (_openBlock(), _createBlock(_component_va_button, {
                key: 0,
                size: "medium",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deactivateCategory()))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.newRecord)
            ? (_openBlock(), _createBlock(_component_va_button, {
                key: 1,
                size: "medium",
                disabled: !_ctx.allowAddCategory,
                onClick: _ctx.addNew
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}